import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { STATUS_INITIAL, STATUS_LOADING, STATUS_SUCCEEDED } from 'myParkdUtils/constants';
import { REHYDRATE } from 'redux-persist';
import { Status, Token, User } from 'types';


export type AuthReducerState = {
    token: Token | null;
    user?: User | null;
    loading: boolean;
    error: any;
    updatePasswordStatus: Status;
    resetPasswordStatus: Status;
};

export const initialAuthReducerState: AuthReducerState = {
    token: null,
    user: null,
    loading: false,
    error: null,
    updatePasswordStatus: STATUS_INITIAL,
    resetPasswordStatus: STATUS_INITIAL
};

export const authSlice = createSlice({
    name: 'auth',
    initialState: initialAuthReducerState,
    reducers: {
        login(state, action: PayloadAction<{ email: string, password: string }>) {
            state.loading = true;
            state.error = null;
        },
        loginCompleted(state, action: PayloadAction<{ token: Token, user: User }>) {
            state.token = action.payload.token;
            state.user = action.payload.user;
            state.loading = false;
        },
        loginError(state, action: PayloadAction<{ error: any }>) {
            state.loading = false;
            state.error = action.payload.error
        },
        logout(state) {
            state.token = null;
            state.user = null;
        },
        logoutCompleted(state) {
            state = initialAuthReducerState;
        },

        changePassword(state, action: PayloadAction<{ oldPassword: string, newPassword: string }>) {
            state.updatePasswordStatus = STATUS_LOADING;
        },
        changePasswordCompleted(state) {
            state.updatePasswordStatus.loading = false;
            state.updatePasswordStatus.succeeded = true;
        },
        changePasswordError(state, action: PayloadAction<{ error: any }>) {
            state.updatePasswordStatus.loading = false;
            state.updatePasswordStatus.error = action.payload.error;
        },

        resetPassword(state, action: PayloadAction<{ email: string }>) {
            state.resetPasswordStatus = STATUS_LOADING;
        },
        resetPasswordCompleted(state) {
            state.resetPasswordStatus = STATUS_SUCCEEDED;
        },
        resetPasswordError(state, action: PayloadAction<{ error: any }>) {
            state.resetPasswordStatus.error = action.payload.error
        }
    },

    extraReducers: (builder) => {
        builder.addCase(REHYDRATE, (state, action) => {
            state.error = null; // clear auth.error after refresh
        });
    },

    selectors: {
        getLocalToken: (state) => state.token
    }
});

export const {
    login,
    loginCompleted,
    loginError,
    logout,
    logoutCompleted,
    changePassword,
    changePasswordCompleted,
    changePasswordError,
    resetPassword,
    resetPasswordCompleted,
    resetPasswordError
} = authSlice.actions;

export default authSlice.reducer;